module.exports = __webpack_public_path__ + "img/afdiag.20c97f93.jpg";